// extracted by mini-css-extract-plugin
export default {"statistics_number":"DashboardTotalSales_statistics_number__qwmuk"};